import { Component, inject, input, output } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { Constants } from "../../../constants/constants";
import { PageMode } from "../../../constants/enums";
import { IntpCountryVisitMemberModel, TableActionEvent } from "../../../models";
import { LanguageService } from "../../../services";
import { ConfirmationModalComponent } from "../../general";
import { DataTableComponent } from "../../table/data-table/data-table";
import { IntpVisitMemberModalComponent } from "../intp-visit-member-modal/intp-visit-member-modal";

@Component({
  selector: "adaa-intp-visit-member-table",
  imports: [DataTableComponent],
  templateUrl: "./intp-visit-member-table.html",
  styleUrl: "./intp-visit-member-table.scss",
})
export class IntpVisitMemberTableComponent {
  private readonly _modalService = inject(NgbModal);
  private readonly _languageService = inject(LanguageService);

  delegationMembers = input.required<IntpCountryVisitMemberModel[]>();
  isDisabled = input<boolean>(false);
  valueChanged = output<IntpCountryVisitMemberModel[]>();

  public get tableData() {
    return this.delegationMembers().filter((e) => e.status !== Constants.OBJECT_STATUS.REMOVE);
  }

  Constants = Constants;

  public addNewClicked() {
    const member: IntpCountryVisitMemberModel = {
      nameAE: "",
      nameEN: "",
      responsibilityAE: "",
      responsibilityEN: "",
      status: Constants.OBJECT_STATUS.ACTIVE,
      fakeId: Math.floor(Math.random() * 217 * 1000),
    };

    this._openEditorModal(member, PageMode.create);
  }

  public actionClicked(event: TableActionEvent) {
    if (event.event === "view") this._openEditorModal(event.data, PageMode.view);
    else if (event.event === "edit") this._openEditorModal(event.data, PageMode.edit);
    else this._openDeleteModal(event.data);
  }

  private _openEditorModal(member: IntpCountryVisitMemberModel, pageMode: PageMode) {
    const modal = this._modalService.open(IntpVisitMemberModalComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      modalDialogClass: this._languageService.modalDirection(),
    });

    modal.componentInstance.pageMode.set(pageMode);
    modal.componentInstance.member.set(member);

    modal.result.then((e) => {
      if (!e) return;
      if (pageMode === PageMode.create) {
        this.delegationMembers().push(e);
      } else {
        const index = this.delegationMembers().findIndex((member) =>
          e.fakeId ? e.fakeId === member.fakeId : e.id === member.id
        );
        if (index > -1) this.delegationMembers().splice(index, 1, e);
      }

      this.valueChanged.emit(this.delegationMembers());
    });
  }

  private _openDeleteModal(member: IntpCountryVisitMemberModel) {
    const modal = this._modalService.open(ConfirmationModalComponent, {
      centered: true,
      size: "md",
      modalDialogClass: this._languageService.modalDirection(),
    });

    modal.componentInstance.header = "international_projects.visits.delete_member_title";
    modal.componentInstance.title = "international_projects.visits.delete_member_msg";

    modal.result.then((e) => {
      if (e) this._deleteConfirmed(member);
    });
  }

  private _deleteConfirmed(member: IntpCountryVisitMemberModel) {
    const delegationMembers = [...this.delegationMembers()];
    if (member.fakeId) {
      this.valueChanged.emit(delegationMembers.filter((e) => e.fakeId !== member.fakeId));
    } else {
      const delegationMember = delegationMembers.find((e) => e.id === member.id);
      if (delegationMember) delegationMember.status = Constants.OBJECT_STATUS.REMOVE;
      this.valueChanged.emit(delegationMembers);
    }
  }
}
